import Modal from '@components/modal/Modal';
import { SuperAdminUser } from 'src/types/shared/SuperAdminUser';
import useRevokeSuperAdminMfa from './hooks/useRevokeSuperAdminMfa';
import Form from '@components/form/Form';

const RevokeSuperAdminMfaModal: React.FC<RevokeSuperAdminMfaModalProps> = ({ user }) => {
    const { handleSubmit, closeModal, isPosting, error } = useRevokeSuperAdminMfa(user);

    return (
        <Modal title={`Revoke MFA for ${user.firstName} ${user.lastName}`} closeModal={closeModal}>
            <p>Are you sure you want to revoke this user's Multi-Factor Authentication (MFA)?</p>
            <Form
                onSubmit={handleSubmit}
                isPosting={isPosting}
                error={error}
                onCancel={closeModal}
            />
        </Modal>
    );
};

interface RevokeSuperAdminMfaModalProps {
    user: SuperAdminUser;
}

export default RevokeSuperAdminMfaModal;
